import React from "react";

const AllUsers = () => {
  return (
    <div>
      <h1>All Users</h1>
    </div>
  );
};

export default AllUsers;
